import { Button } from "@inkblot-therapy/squid"
import { useTranslation } from "react-i18next"

interface Props {
  errorMessage: string
  retryText?: string
  onRetry?: () => void
  title: string
  error?: string | null
}

export function ErrorPage({
  errorMessage,
  onRetry,
  retryText,
  title,
  error,
}: Props) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col max-w-2xl">
      <p className="[font-size:var(--alias-font-display-xl-font-size)] [font-family:var(--alias-font-display-xl-font-family)]">
        {title}
      </p>
      <div className="my-8 [font-size:var(--alias-font-subtitle-lg-font-size)] [font-family:var(--alias-font-subtitle-lg-font-weight)]">
        <p>{error || errorMessage}</p>
      </div>
      <div>
        {onRetry && (
          <Button variant="primary" onClick={() => onRetry()}>
            {retryText ?? t("client.errorBoundary.retry")}
          </Button>
        )}
      </div>
    </div>
  )
}
